import { useState } from 'react';
import { toast } from 'sonner';
import { useReadersStore } from '@/store/readers.store';
import { useRewardsStore } from '@/store/rewards.store';
import { rewardsService } from '@/services/rewards.service';
import type { EggTierId } from '@/types/rewards';

export function usePurchaseEgg() {
  const [purchasing, setPurchasing] = useState(false);
  const selectedReader = useReadersStore((s) => s.selectedReader());
  const incrementCoinBalance = useReadersStore((s) => s.incrementCoinBalance);
  const addEgg = useRewardsStore((s) => s.addEgg);
  const eggTiers = useRewardsStore((s) => s.eggTiers);

  async function purchase(tierId: EggTierId) {
    if (!selectedReader || purchasing) return;
    setPurchasing(true);

    const tier = eggTiers.find((t) => t.id === tierId);
    if (!tier) {
      toast.error('Unknown egg tier.');
      setPurchasing(false);
      return;
    }

    // Optimistic coin debit
    incrementCoinBalance(selectedReader.id, -tier.cost);

    try {
      const egg = await rewardsService.purchaseEgg(selectedReader.id, tierId);
      addEgg(egg);
      toast.success(`${tier.name} added to the nest!`);
    } catch (err) {
      // Rollback optimistic debit
      incrementCoinBalance(selectedReader.id, tier.cost);
      const msg = err instanceof Error ? err.message : 'Failed to purchase egg.';
      toast.error(msg);
      console.error('[usePurchaseEgg]', msg, err);
    } finally {
      setPurchasing(false);
    }
  }

  return { purchase, purchasing };
}
